import httpService from "./httpService";
import auth from "./loginService";

export async function getBloodP() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/bloodp`, config);
}
export async function getWeights() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/weights`, config);
}

export async function getEcgs() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/ecgs`, config);
}

export async function getActivities() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/Activities`, config);
}

export async function getInvoices() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/Invoices`, config);
}
export async function getHafnayot() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/Hafnayot`, config);
}

export async function getHafnayotFile(fileName) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/getHafnayotFile/${fileName}`, config);
}
export async function getCardioR() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/cardioR`, config);
}

export async function getEcgFile(ecgId) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/File/GetEcg?ecgid=${ecgId}`, config);
}
export async function getInvoiceFile(docNum, docType) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/File/Getinvoice/${docType}/${docNum}`, config);
}

export async function getPatients() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/results/patients`, config);
}

export async function getCardioRFile(ifFinal, reportId) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`File/GetCardioREvent/${ifFinal}/${reportId}`, config);
}
export async function getSummaryReport(patid) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`File/GetSummaryReport/${patid}`, config);
}
export async function getCoverPaper(patid) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`File/GetCoverPaper/${patid}`, config);
}

export async function checkSummaryReport(patid) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`File/CheckSummaryReport/${patid}`, config);
}

export async function getuserDetails() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/customer/details`, config);
}

export async function checkDigital() {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.get(`/customer/CheckDigital`, config);
}

export async function insertDigital(digital) {
  const config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };
  return httpService.post(`/customer/insertDigital`, digital, config);
}
export default {
  getBloodP,
  getWeights,
  getEcgs,
  getActivities,
  getCardioR,
  getuserDetails,
  getEcgFile,
  getCardioRFile,
  getSummaryReport,
  getPatients,
  checkDigital,
  insertDigital,
  checkSummaryReport,
  getCoverPaper,
  getInvoices,
  getHafnayot,
  getInvoiceFile,
  getHafnayotFile,
};
